import axios from 'axios'

axios.defaults.timeout = 30000
axios.defaults.baseURL =''


//http request 拦截器
axios.interceptors.request.use(
    config => {
        config.data = manageData(config.data);
        config.headers = {
        'Content-Type':'application/x-www-form-urlencoded'
        }
        return config;
    },
    error => {
        return Promise.reject(err);
    }
)


//http response 拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        return Promise.reject(error)
    }
)


/**
 * 封装get方法
 * @param url
 * @param params
 * @returns {Promise}
 */

export function get(params={}){
    return new Promise((resolve,reject) => {
        axios.get(process.env.BASE_API,{
        params:params
        })
        .then(response => {
        resolve(response.data);
        })
        .catch(err => {
        reject(err)
        })
    })
}


/**
 * 封装post请求
 * @param url
 * @param params
 * @returns {Promise}
 */

 export function post(params = {}){
    return new Promise((resolve,reject) => {
        axios.post(process.env.BASE_API,params)
            .then(response => {
                resolve(response.data);
            },err => {
                reject(err)
            })
    })
 }
 function manageData(params){
    let src = '0000100001|6002021000'

    // 本地有渠道src优先用本地
    if(localStorage.getItem('fromSrc')){
        src = localStorage.getItem('fromSrc')
    }else{
        if(localStorage.getItem('fromSrc')){
            if(systemType() == 'ios'){
                src = '0000100001|0402021000'
            }else{
                src = '0000100001|0302021000'
            }
            localStorage.setItem('fromSrc',src)
        }
    }
    let requestData = {
        message: {
            head: {
                sysType: params.sysType,
                src: src,
                deviceId: (new Date().getTime()+1)+"",
                timeStamp: new Date().getTime(),
                transactionType: params.transactionType,
                messageID: '9999201508200955426',
                messengerID: "9999",
                imei: "jsjH5",
                ua: window.navigator.userAgent
            },
            body: params.data
        }
    }
    return 'transMessage=' + JSON.stringify(requestData)
 }
 /**
  * 获取指定的URL参数值
  * 参数：paramName 参数名
  * 调用方法:this.utils.getUrlParam("name")
  * 返回值:tyler
  */
 function getUrlParam(paramName) {
     var query = window.location.search.substring(1)
     var vars = query.split("&")
     for (var i=0;i<vars.length;i++) {
             var pair = vars[i].split("=");
             if(pair[0] == paramName){return pair[1]}
     }
     return false
 }
/**
 * [systemType 判断手机系统类型]
 *
 * @return  {[type]}  [return description]
 */
function systemType() {
    var u = navigator.userAgent, app = navigator.appVersion;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        return 'Android'
    }
    if (isIOS) {
        return 'ios'
    }
}


// WEBPACK FOOTER //
// ./src/api/http.js